export const CONFIG = {
  API_URL: "https://devextremereactmenu.azurewebsites.net/OdataService1.svc",
  API_KEY:
    "zJj1ksOT443ZZIu/pm78cyoQEnQ+CwHKCHtlW6cXy5eYhcoljmZS/0uofnWi0we8TJFLy3MZBQpLL4LE5HCsm0O26DNYznWsNslXRhQMtycBUWZiXcaPhRxkUEPziaIHlxhsyw=="
};
